// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_2-0";
export var footer = "_2-2";
export var infoSection = "_2-3";
export var infoSectionContainer = "_2-4";
export var infoSectionTitleRow = "_2-5";
export var itemDetails = "_2-6";
export var line = "_2-7";
export var lineItemImage = "_2-1";
export var lineItems = "_2-8";
export var modalContent = "_2-9";
export var multiLineInfo = "_2-a";
export var orderName = "_2-b";
export var strong = "_2-c";